import { CalendarData } from '@lts-web/data-objects';
import ObjectDataList from './ObjectDataList';

class CalendarList extends ObjectDataList {
    static formatMonth = (month, year) => month + '/' + year;

    constructor (type, calendarDataList, includedMonths) {
        super(type, calendarDataList);

        this._insertedMonths = includedMonths || [];
    }

    getCalendarData (date) {
        return this.find( calendarData => calendarData.getDate() === date);
    }

    hasCalendarData (date) {
        const data = this.getCalendarData(date);
        return data instanceof CalendarData;
    }

    addCalendarData (calendarData) {
        if (!(calendarData instanceof CalendarData))
            throw new TypeError('First argument must be of instance `CalendarData`');

        return this.getAll().push(calendarData) ? calendarData : null;
    }

    getFirstCalendarData () {
        return (this.getAscendingData() || [null])[0];
    }

    getInsertedMonths () {
        return this._insertedMonths;
    }

    insertMonth (month, year) {
        const formatted = CalendarList.formatMonth(month, year);
        return this.getInsertedMonths().push(formatted);
    }

    removeMonth (month, year) {
        const months = this._insertedMonths;
        const formatted = CalendarList.formatMonth(month, year);

        return months.splice(months.indexOf(formatted), 1);
    }

    hasMonth (month, year) {
        const formatted = CalendarList.formatMonth(month, year);
        return this._insertedMonths.indexOf(formatted) > -1;
    }

    getAscendingData () {
        return this.sort(function(a, b){
            a = moment(a.getDate(), a.getFormat());
            b = moment(b.getDate(), b.getFormat());

            if (a.isSame(b)) {
                return 0;
            } else if (a.isBefore(b)) {
                return -1;
            } else {
                return 1;
            }
        });
    }

    getDescendingData () {
        return this.sort(function(a, b){
            a = moment(a.getDate(), a.getFormat());
            b = moment(b.getDate(), b.getFormat());

            if (a.isSame(b)) {
                return 0;
            } else if (a.isAfter(b)) {
                return -1;
            } else {
                return 1;
            }
        });
    }
}

export default CalendarList;